/* In-app help panel and product tours (web/src/help, web/src/tour). Kept apart from uk.ts/en.ts to keep merges small. */
export const helpUk = {
  'help.title': 'Довідка',
  'help.open': 'Довідка по сторінці',
  'help.close': 'Закрити довідку',
  'help.search': 'Пошук у довідці',
  'help.searchPlaceholder': 'Пошук у довідці: кнопка, статус, розділ…',
  'help.found': 'Знайдено: {n}',
  'help.noResults': 'Нічого не знайдено',
  'help.noResultsHint': 'Спробуйте інше слово або початок слова.',
  'help.backToPage': 'До довідки цієї сторінки',
  'help.sectionFallback': 'Окремої довідки для цієї сторінки ще немає — показано довідку розділу.',
  'help.noEntry': 'Довідки для цієї сторінки ще немає.',
  'help.who': 'Хто користується',
  'help.workflows': 'Як працювати',
  'help.controls': 'Кнопки й елементи',
  'help.controlsHint': 'Наведіть на рядок — елемент підсвітиться на сторінці.',
  'help.when': 'Коли',
  'help.statuses': 'Статуси й позначки',
  'help.sources': 'Звідки дані',
  'help.faq': 'Часті питання',
  'help.related': 'Пов’язані сторінки',
  'help.startTour': 'Пройти тур цією сторінкою',
  'help.resumeTour': 'Продовжити тур (крок {n})',
  'help.implementation': 'Етап впровадження',
  'help.welcomeTour': 'Вступний тур системи',
  'help.shortcuts': 'Гарячі клавіші',
  'help.keyHint': 'Відкрити: ? або F1 · закрити: Esc',
  'tour.next': 'Далі',
  'tour.back': 'Назад',
  'tour.done': 'Готово',
  'tour.skip': 'Пропустити тур',
  'tour.pause': 'Призупинити тур',
  'tour.step': 'Крок {n} з {total}',
  'tour.label': 'Тур: {title}',
  'tour.paused': 'Тур призупинено. Продовжити можна з довідки (?).',
  'tour.completed': 'Тур завершено. Повторити можна з довідки (?).',
  'user.help': 'Довідка',
  'user.tour': 'Пройти вступний тур',
}

export const helpEn: Partial<Record<keyof typeof helpUk, string>> = {
  'help.title': 'Help',
  'help.open': 'Help for this page',
  'help.close': 'Close help',
  'help.search': 'Search help',
  'help.searchPlaceholder': 'Search help: button, status, section…',
  'help.found': 'Found: {n}',
  'help.noResults': 'Nothing found',
  'help.noResultsHint': 'Try another word or the start of a word.',
  'help.backToPage': 'Back to this page’s help',
  'help.sectionFallback': 'This page has no help of its own yet — showing the section’s help.',
  'help.noEntry': 'There is no help for this page yet.',
  'help.who': 'Who uses it',
  'help.workflows': 'How to work',
  'help.controls': 'Buttons and controls',
  'help.controlsHint': 'Hover a row to highlight the control on the page.',
  'help.when': 'When',
  'help.statuses': 'Statuses and badges',
  'help.sources': 'Where the data comes from',
  'help.faq': 'FAQ',
  'help.related': 'Related pages',
  'help.startTour': 'Take the tour of this page',
  'help.resumeTour': 'Resume the tour (step {n})',
  'help.implementation': 'Rollout stage',
  'help.welcomeTour': 'Product tour',
  'help.shortcuts': 'Keyboard shortcuts',
  'help.keyHint': 'Open: ? or F1 · close: Esc',
  'tour.next': 'Next',
  'tour.back': 'Back',
  'tour.done': 'Done',
  'tour.skip': 'Skip tour',
  'tour.pause': 'Pause tour',
  'tour.step': 'Step {n} of {total}',
  'tour.label': 'Tour: {title}',
  'tour.paused': 'Tour paused. Resume it from Help (?).',
  'tour.completed': 'Tour finished. Replay it from Help (?).',
  'user.help': 'Help',
  'user.tour': 'Take the product tour',
}
